import React from 'react';
import Modal from './Modal';

interface InstallationStepsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const InstallationStepsModal: React.FC<InstallationStepsModalProps> = ({
  isOpen,
  onClose
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Add to Homepage">
      <div className='space-y-4'>
        <div className='text-center p-3 bg-gray-100 dark:bg-gray-700 rounded-lg'>
          <p className='text-gray-700 dark:text-gray-300 mb-4'>
            Follow these steps to install Riddl on your device:
          </p>
          
          <div className='space-y-3 text-left'>
            <div className='flex items-start space-x-3'>
              <span className='bg-teal-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold flex-shrink-0 mt-0.5'>1</span>
              <div>
                <p className='font-semibold text-gray-900 dark:text-white'>iOS (Safari)</p>
                <p className='text-sm text-gray-600 dark:text-gray-400'>Tap the Share button, then "Add to Home Screen"</p>
              </div>
            </div>
            
            <div className='flex items-start space-x-3'>
              <span className='bg-teal-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold flex-shrink-0 mt-0.5'>2</span>
              <div>
                <p className='font-semibold text-gray-900 dark:text-white'>Android (Chrome)</p>
                <p className='text-sm text-gray-600 dark:text-gray-400'>Tap the menu button, then "Add to Home screen"</p>
              </div>
            </div>
            
            <div className='flex items-start space-x-3'>
              <span className='bg-teal-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold flex-shrink-0 mt-0.5'>3</span>
              <div>
                <p className='font-semibold text-gray-900 dark:text-white'>Desktop (Chrome/Edge)</p>
                <p className='text-sm text-gray-600 dark:text-gray-400'>Click the install icon in the address bar</p>
              </div>
            </div>
          </div>
        </div>

        <div className='flex justify-end'>
          <button 
            onClick={onClose}
            className='px-4 py-2 bg-gray-500 hover:bg-gray-600 text-white rounded-lg transition-colors'
          >
            Got it!
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default InstallationStepsModal;
